export default "__VITE_ASSET__CeO85UAA__"